import React, { FC, useState, useEffect, ChangeEvent } from 'react';
import { Button, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

const { WARRANTY_TYPES } = CONSTANTS;

type WarrantyTypeDialogProps = {
    handleClose: () => void;
    open: boolean;
    handleConfirm: (warrantyType: string) => void;
    warrantyType: string;
};

const WarrantyTypeDialog: FC<WarrantyTypeDialogProps> = ({
    handleClose,
    open,
    handleConfirm,
    warrantyType,
}: WarrantyTypeDialogProps) => {
    const { t: translate } = useTranslation(['orders, common']);
    const [value, setValue] = useState('NOT_CEMENTED');

    useEffect(() => {
        setValue('NOT_CEMENTED');
    }, [warrantyType]);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };

    const handleClick = () => {
        handleConfirm(value);
    };

    return (
        <DHDialog
            title={translate('orders:HAS_THE_CONSTRUCTION_BEEN_CEMENTED')}
            maxWidth="sm"
            fullWidth
            open={open}
            onClose={handleClose}
            actions={
                <Button onClick={handleClick} variant="contained" autoFocus>
                    {translate('common:OK')}
                </Button>
            }
        >
            <FormControl component="fieldset">
                <RadioGroup value={value} onChange={handleChange}>
                    {WARRANTY_TYPES.map((elem: string) => (
                        <FormControlLabel
                            key={elem}
                            value={elem}
                            control={<Radio color="secondary" />}
                            label={translate(`orders:${elem}`)}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </DHDialog>
    );
};

export default WarrantyTypeDialog;
